import LoadsTask from "./LoadsTask";

export default LoadsTask;